var Const = /** @class */ (function () {
    function Const() {
    }
    Const.RUN_GET_PROFILE_INFO = '/RUN_GET_PROFILE_INFO';
    Const.SET_PROFILE_INFO = '/SET_PROFILE_INFO';
    Const.GET_PROFILE_INFO = '/GET_PROFILE_INFO';
    Const.RUN_GENERATE_2FA_QRCODE = '/RUN_GENERATE_2FA_QRCODE';
    Const.RUN_VERIFY_2FA_QRCODE = '/RUN_VERIFY_2FA_QRCODE';
    Const.RUN_DISABLE_2FA_QRCODE = '/RUN_DISABLE_2FA_QRCODE';
    Const.RUN_GET_PAYMENT_METHODS = '/RUN_GET_PAYMENT_METHODS';
    Const.GET_PAYMENT_METHODS = '/GET_PAYMENT_METHODS';
    Const.SET_PAYMENT_METHODS = '/SET_PAYMENT_METHODS';
    Const.GET_STATE_REFRESH_DATA = '/GET_STATE_REFRESH_DATA';
    Const.SET_STATE_REFRESH_DATA = '/SET_STATE_REFRESH_DATA';
    // =================Trading Account list============================
    Const.RUN_GET_NOTIFICATION_LIST = '/RUN_GET_NOTIFICATION_LIST';
    Const.GET_NOTIFICATION_LIST = '/GET_NOTIFICATION_LIST';
    Const.SET_NOTIFICATION_LIST = '/SET_NOTIFICATION_LIST';
    Const.SET_UNREAD_NOTIFICATION_DATA = '/SET_UNREAD_NOTIFICATION_DATA';
    Const.GET_UNREAD_NOTIFICATION_DATA = '/GET_UNREAD_NOTIFICATION_DATA';
    Const.RUN_READ_UNREAD_NOTIFICATION = '/RUN_READ_UNREAD_NOTIFICATION';
    Const.RUN_NOTIFICATION_SETTINGS = '/RUN_NOTIFICATION_SETTINGS';
    Const.SET_NOTIFICATION_SETTINGS = '/SET_NOTIFICATION_SETTINGS';
    Const.GET_NOTIFICATION_SETTINGS = '/GET_NOTIFICATION_SETTINGS';
    Const.RUN_NOTIFICATION_GET_SETTINGS = '/RUN_NOTIFICATION_GET_SETTINGS';
    Const.SET_NOTIFICATION_GET_SETTINGS = '/SET_NOTIFICATION_GET_SETTINGS';
    Const.GET_NOTIFICATION_GET_SETTINGS = '/GET_NOTIFICATION_GET_SETTINGS';
    Const.RUN_NOTIFICATION_ENABLE_GET_SETTINGS = '/RUN_NOTIFICATION_ENABLE_GET_SETTINGS';
    Const.SET_NOTIFICATION_ENABLE_GET_SETTINGS = '/SET_NOTIFICATION_ENABLE_GET_SETTINGS';
    Const.GET_NOTIFICATION_ENABLE_GET_SETTINGS = '/GET_NOTIFICATION_ENABLE_GET_SETTINGS';
    Const.RUN_GET_API_KEYS = '/RUN_GET_API_KEYS';
    Const.RUN_UPDATE_API_KEYS = '/RUN_UPDATE_API_KEYS';
    Const.RUN_UPDATE_API_WEBOOK = '/RUN_UPDATE_API_WEBOOK';
    Const.RUN_GET_WALLET_MARGIN = '/RUN_GET_WALLET_MARGIN';
    Const.RUN_CONFIRM_WALLET_TRANSACTION = '/RUN_CONFIRM_WALLET_TRANSACTION';
    /** Crypto Addresses */
    Const.RUN_GET_CRYPTO_ADDRESSES = '/RUN_GET_CRYPTO_ADDRESSES';
    Const.SET_CRYPTO_ADDRESSES = '/SET_CRYPTO_ADDRESSES';
    Const.GET_CRYPTO_ADDRESSES = '/GET_CRYPTO_ADDRESSES';
    /** Bank Addresses  */
    Const.RUN_GET_BANK_ADDRESSES = '/RUN_GET_BANK_ADDRESSES';
    Const.SET_BANK_ADDRESSES = '/SET_BANK_ADDRESSES';
    Const.GET_BANK_ADDRESSES = '/GET_BANK_ADDRESSES';
    /** Bank Addresses  */
    Const.RUN_GET_WATCH_LIST = '/RUN_GET_WATCH_LIST';
    Const.SET_WATCH_LIST = '/SET_WATCH_LIST';
    Const.GET_WATCH_LIST = '/GET_WATCH_LIST';
    Const.RUN_GET_NEWS_LIST = '/RUN_GET_NEWS_LIST';
    Const.SET_NEWS_LIST = '/SET_NEWS_LIST';
    Const.GET_NEWS_LIST = '/GET_NEWS_LIST';
    Const.SET_CRYPTO_NEWS_LIST = '/SET_CRYPTO_NEWS_LIST';
    Const.GET_CRYPTO_NEWS_LIST = '/GET_CRYPTO_NEWS_LIST';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/commonAll/provider/lib/const.cls.ts
// module id = CPps
// module chunks = 1